import React from 'react';
import { render } from 'react-dom';
import { makeData, Logo, Tips, round } from '../Utility/utility.js';
import './ResearchTable.css';
import { AppContext } from '../Pages/App';
import { FadeLoader } from 'react-spinners';
import latinize from 'latinize';
import axios from 'axios';
import { apiServerUrl } from '../config';
import { authHeader, requestOptions } from '../_helpers';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import Tooltip from 'rc-tooltip';

// Import React Table
import ReactTable from 'react-table';
import 'react-table/react-table.css';

export const navigatePage = () => dispatch => {
  /* do something before redirection */
  console.log('navigating');
  dispatch(push('/research'));
};

class ResearchTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // data: makeData()
      filter0: '5',
      filter1: '5',
      filter2: '5',
      operator0: 'gt',
      operator1: 'gt',
      operator2: 'gt',
      columns: ['', '', '', '', '', '', '', '', '', '', '', ''],
      column_type: 'basic',
      position: 'skater',
      season: '20182019',
      players: this.props.players,
      league: 'nhl',
      season_type: '02',
      data: []
    };
  }

  handleChange(e, id) {
    /*
      if(e.target.value === "Career") {
          this.setState({season: e.target.value});
      }
      */
    console.log(
      e.target.value,
      id,
      this.state.columns.find(x => (x.id = id.toString()))
    );
    this.refs.researchTable.filterColumn(
      this.state.columns.find(x => (x.id = id.toString())),
      e.target.value
    );
  }
  changeFilter(e, index) {
    if (index === 0) {
      this.setState({ filter0: e.target.value });
    } else if (index === 1) {
      this.setState({ filter1: e.target.value });
    } else if (index === 2) {
      this.setState({ filter2: e.target.value });
    }
    //console.log(this.state.filter0, this.state.filter1, this.state.filter2);
  }
  changeModifier(e, index) {
    if (index === 0) {
      this.setState({ operator0: e.target.value });
    } else if (index === 1) {
      this.setState({ operator1: e.target.value });
    } else if (index === 2) {
      this.setState({ operator2: e.target.value });
    }
    //console.log(this.state.operator0, this.state.operator1, this.state.operator2);
  }
  sort(e) {
    this.setState({ sorted: [{ id: e.target.value }] });
  }
  toGoalies(e) {
    let cols = this.getColumns(
      this.state.data.columns.goalie,
      'goalie',
      this.state.league,
      this.state.season,
      this.state.season_type
    );
    let goalies = this.state.data.stats.filter(x => x.position === 'G');
    this.setState({
      columns: cols,
      column_type: 'goalie',
      position: 'goalie',
      players: goalies,
      sorted: [{ id: '7', desc: true }]
    });
  }
  toSkaters(e) {
    let cols = this.getColumns(
      this.state.data.columns.basic,
      'skater',
      this.state.league,
      this.state.season,
      this.state.season_type
    );
    let skaters = this.state.data.stats.filter(x => x.position !== 'G');
    this.setState({
      columns: cols,
      column_type: 'basic',
      position: 'skater',
      players: skaters,
      sorted: [{ id: '10', desc: true }]
    });
  }
  changeColumnType(e) {
    if (e.target.value === 'basic') {
      let cols = this.getColumns(
        this.state.data.columns.basic,
        'skater',
        this.state.league,
        this.state.season,
        this.state.season_type
      );
      this.setState({
        columns: cols,
        column_type: 'basic',
        sorted: [{ id: '10', desc: true }]
      });
    } else if (e.target.value === 'advanced') {
      let cols = this.getColumns(
        this.state.data.columns.advanced,
        'skater',
        this.state.league,
        this.state.season,
        this.state.season_type
      );
      this.setState({
        columns: cols,
        column_type: 'advanced',
        sorted: [{ id: '24', desc: true }]
      });
    }
  }

  changeLeague(e) {
    let league = e.target.value;
    let currentComponent = this;
    axios
      .get(
        apiServerUrl +
          '/stats?league=' +
          league +
          '&season=' +
          (this.state.season !== '20182019' ? this.state.season : '20172018') +
          '&season_type=' +
          this.state.season_type,
        requestOptions()
      )
      .then(function(response) {
        let players =
          currentComponent.state.position === 'skater'
            ? response.data.stats.filter(x => x.position !== 'G')
            : response.data.stats.filter(x => x.position === 'G');
        let id = league === 'nhl' ? '10' : '7';
        let cols = currentComponent.getColumns(
          response.data.columns[currentComponent.state.column_type],
          currentComponent.state.position,
          league,
          currentComponent.state.season,
          currentComponent.state.season_type
        );
        console.log(response.data);
        currentComponent.setState({
          data: response.data,
          players: players,
          position: currentComponent.state.position,
          columns: cols,
          sorted: [{ id: id, desc: true }]
        });
      });
  }

  changeSeason(e) {
    let season = e.target.value;
    let currentComponent = this;
    axios
      .get(
        apiServerUrl +
          '/stats?league=' +
          this.state.league +
          '&season=' +
          season +
          '&season_type=' +
          this.state.season_type,
        requestOptions()
      )
      .then(function(response) {
        let pos =
          currentComponent.state.position === 'skater'
            ? response.data.stats.filter(x => x.position !== 'G')
            : response.data.stats.filter(x => x.position === 'G');
        console.log(response.data);
        currentComponent.setState({
          data: response.data,
          players: pos
        });
      });
    if (this.state.position === 'goalie') {
      let cols = this.getColumns(
        this.state.data.columns.goalie,
        this.state.position,
        this.state.league,
        season,
        this.state.season_type
      );
      this.setState({
        columns: cols,
        column_type: 'goalie',
        season: season
      });
    } else {
      let cols = this.getColumns(
        this.state.data.columns.basic,
        this.state.position,
        this.state.league,
        season,
        this.state.season_type
      );
      this.setState({
        columns: cols,
        column_type: 'basic',
        season: season
      });
    }
  }
  changeSeasonType(e) {
    let season_type = e.target.value;
    let currentComponent = this;
    axios
      .get(
        apiServerUrl +
          '/stats?league=' +
          this.state.league +
          '&season=' +
          this.state.season +
          '&season_type=' +
          season_type,
        requestOptions()
      )
      .then(function(response) {
        let pos =
          currentComponent.state.position === 'skater'
            ? response.data.stats.filter(x => x.position !== 'G')
            : response.data.stats.filter(x => x.position === 'G');
        console.log(response.data);
        currentComponent.setState({
          data: response.data,
          players: pos
        });
      });
    if (this.state.position === 'goalie') {
      let cols = this.getColumns(
        this.state.data.columns.goalie,
        this.state.position,
        this.state.league,
        this.state.season,
        e.target.value
      );
      this.setState({
        columns: cols,
        column_type: 'goalie',
        season_type: e.target.value
      });
    } else {
      let cols = this.getColumns(
        this.state.data.columns.basic,
        this.state.position,
        this.state.league,
        this.state.season,
        e.target.value
      );
      this.setState({
        columns: cols,
        column_type: 'basic',
        season_type: e.target.value
      });
    }
  }

  openExpand(id) {
    console.log('executing expand ', id);
    this.props.dispatch(push('/players?player_id=' + id));
  }

  componentDidMount() {
    let currentComponent = this;
    axios
      .get(
        apiServerUrl + '/stats?league=nhl&season=20182019&season_type=02',
        requestOptions()
      )
      .then(function(response) {
        console.log(response.data.stats);
        if (response.data) {
          let cols = currentComponent.getColumns(
            response.data.columns.basic,
            'skater',
            'nhl',
            '20182019',
            '02'
          );
          console.log(cols);
          currentComponent.setState({
            columns: cols,
            players: response.data.stats.filter(x => x.position !== 'G'),
            data: response.data
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  getColumns(cols, position, league, season, season_type) {
    console.log(cols, position, league, season, season_type);
    let currentComponent = this;
    currentComponent.setState({ position: position, league: league });
    let newColumns = [];
    let columns = [];
    for (var i in cols) {
      columns.push(cols[i][0]);
    }
    columns.map((key, value) => {
      console.log(key, value);
      if (key === 'player_name') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          accessor: d => d[key],
          id: '0',
          minWidth: 160,
          defaultSortDesc: false,
          filterMethod: (filter, row) => {
            return row[filter.id]
              ? latinize(row[filter.id])
                  .toLowerCase()
                  .includes(filter.value)
              : null;
          }
        });
      } else if (key === 'team' && this.state.season !== 'Career') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: '1',
          accessor: d => d[key],
          defaultSortDesc: false,
          minWidth: 50
        });
      } else if (key === 'position') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: '2',
          defaultSortDesc: false,
          accessor: d => d[key],
          minWidth: 50,
          filterMethod: (filter, row) => {
            return row[filter.id] === filter.value;
          }
        });
      } else if (key === 'handedness') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: '3',
          accessor: d => d[key],
          minWidth: 50
        });
      } else if (key === 'age') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: '4',
          accessor: d => d[key],
          defaultSortDesc: false,
          minWidth: 40
        });
      } else if (key === 'games_goalie') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: '3',
          accessor: d => d[key],
          minWidth: 40
        });
      } else if (key === 'toi_per_game') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: value.toString(),
          accessor: d => (d[key] ? d[key] : null),
          minWidth: 60,
          sortMethod: (a, b, desc) => {
            let aMins =
              a === null ? (desc ? -Infinity : Infinity) : +a.split(':')[0];
            let bMins =
              b === null ? (desc ? -Infinity : Infinity) : +b.split(':')[0];
            if (aMins > bMins) {
              return 1;
            } else if (aMins < bMins) {
              return -1;
            } else if (aMins === bMins) {
              let aSecs = a ? +a.split(':')[1] : null;
              let bSecs = b ? +b.split(':')[1] : null;
              if (aSecs > bSecs) {
                return 1;
              } else if (aSecs < bSecs) {
                return -1;
              }
            }
            return 0;
          },
          filterMethod: (filter, row) => {
            let a =
              row[filter.id] === null
                ? -Infinity
                : +row[filter.id].split(':')[0];
            if (filter.id === this.state.columns[this.state.filter0].id) {
              //'28'
              var operator = this.state.operator0;
            } else if (
              filter.id === this.state.columns[this.state.filter1].id
            ) {
              var operator = this.state.operator1;
            } else if (
              filter.id === this.state.columns[this.state.filter2].id
            ) {
              var operator = this.state.operator2;
            } else {
              return row[filter.id] === filter.value;
            }
            if (operator === '' || operator === 'equals') {
              return a === filter.value ? row[filter.id] : null;
            } else if (operator === 'gt') {
              return a > filter.value ? row[filter.id] : null;
            } else if (operator === 'lt') {
              return a < filter.value ? row[filter.id] : null;
            }
            return 0;
          }
        });
      } else if (key === 'toi') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: value.toString(),
          accessor: d => d[key],
          minWidth: 65,
          sortMethod: (a, b, desc) => {
            let aMins =
              a === null ? (desc ? -Infinity : Infinity) : +a.split(':')[0];
            let bMins =
              b === null ? (desc ? -Infinity : Infinity) : +b.split(':')[0];
            if (aMins > bMins) {
              return 1;
            } else if (aMins < bMins) {
              return -1;
            } else if (aMins === bMins) {
              let aSecs = a ? +a.split(':')[1] : null;
              let bSecs = b ? +b.split(':')[1] : null;
              if (aSecs > bSecs) {
                return 1;
              } else if (aSecs < bSecs) {
                return -1;
              }
            }
            return 0;
          },
          filterMethod: (filter, row) => {
            let a =
              row[filter.id] === null
                ? -Infinity
                : +row[filter.id].split(':')[0];
            if (filter.id === this.state.columns[this.state.filter0].id) {
              //'28'
              var operator = this.state.operator0;
            } else if (
              filter.id === this.state.columns[this.state.filter1].id
            ) {
              var operator = this.state.operator1;
            } else if (
              filter.id === this.state.columns[this.state.filter2].id
            ) {
              var operator = this.state.operator2;
            } else {
              return row[filter.id] === filter.value;
            }
            if (operator === '' || operator === 'equals') {
              return a === filter.value ? row[filter.id] : null;
            } else if (operator === 'gt') {
              return a > filter.value ? row[filter.id] : null;
            } else if (operator === 'lt') {
              return a < filter.value ? row[filter.id] : null;
            }
            return 0;
          }
        });
      } else if (key === 'sv_pct' && position === 'goalie') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: value.toString(),
          accessor: d => (d[key] ? +d[key].toFixed(4) : null),
          minWidth: 60
        });
      } else if (key === 'goalie_so_save_pct') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: value.toString(),
          accessor: d => (d[key] ? +d[key].toFixed(4) : null),
          minWidth: 60
        });
      } else if (key === 'gaa' && position === 'goalie') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: value.toString(),
          defaultSortDesc: false,
          accessor: d => (d[key] ? +d[key].toFixed(2) : null),
          minWidth: 60
        });
      } else if (key === 'fo_pct' && position !== 'goalie') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: value.toString(),
          accessor: d => (d[key] ? +(d[key] * 100).toFixed(2) : 0.0),
          minWidth: 50
        });
      } else if (
        key === 'shot_pct' ||
        key === 'corsi_pct' ||
        key === 'corsi_rel' ||
        key === 'fenwick_pct' ||
        key === 'fenwick_rel' ||
        key === 'team_sht_pct_for_oi' ||
        key === 'corsi_rel' ||
        key === 'team_sv_pct_for_oi' ||
        key === 'shot_thru_pct'
      ) {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: value.toString(),
          accessor: d => (d[key] ? +(d[key] * 100).toFixed(2) : 0),
          minWidth: 50
        });
      } else if (key === 'team_sv_pct_for_oi') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: value.toString(),
          accessor: d => (d[key] ? +d[key].toFixed(2) : null),
          minWidth: 50
        });
      } else if (key === 'pdo') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: value.toString(),
          accessor: d => (d[key] ? +d[key].toFixed(2) : 0),
          minWidth: 50
        });
      } else if (key === 'oz_starts_pct') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: value.toString(),
          accessor: d => (d[key] ? +(d[key] * 100).toFixed(2) : 0),
          minWidth: 60
        });
      } else if (key === 'dz_starts_pct') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: value.toString(),
          accessor: d => (d[key] ? +(d[key] * 100).toFixed(2) : 0),
          minWidth: 60
        });
      } else if (key === 'toi_ev') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: value.toString(),
          //accessor: d => (d[key] ? d[key].toFixed(2) : null),
          accessor: d => (d[key] ? d[key] : null),
          minWidth: 60,
          sortMethod: (a, b, desc) => {
            let aMins =
              a === null ? (desc ? -Infinity : Infinity) : +a.split(':')[0];
            let bMins =
              b === null ? (desc ? -Infinity : Infinity) : +b.split(':')[0];
            if (aMins > bMins) {
              return 1;
            } else if (aMins < bMins) {
              return -1;
            } else if (aMins === bMins) {
              let aSecs = a.split(':')[1];
              let bSecs = b.split(':')[1];
              if (aSecs > bSecs) {
                return 1;
              } else if (aSecs < bSecs) {
                return -1;
              }
            }
            return 0;
          }
        });
      } else if (key === 'toi_ev_per_game') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: value.toString(),
          //accessor: d => (d[key] ? d[key].toFixed(2) : null),
          accessor: d => (d[key] ? d[key] : null),
          minWidth: 60,
          sortMethod: (a, b, desc) => {
            let aMins =
              a === null ? (desc ? -Infinity : Infinity) : +a.split(':')[0];
            let bMins =
              b === null ? (desc ? -Infinity : Infinity) : +b.split(':')[0];
            if (aMins > bMins) {
              return 1;
            } else if (aMins < bMins) {
              return -1;
            } else if (aMins === bMins) {
              let aSecs = a.split(':')[1];
              let bSecs = b.split(':')[1];
              if (aSecs > bSecs) {
                return 1;
              } else if (aSecs < bSecs) {
                return -1;
              }
            }
            return 0;
          }
        });
      } else if (key === 'henri') {
        let cols = [
          {
            Header: 'HENRI',
            id: value.toString(),
            accessor: d => (d[key] ? round(d[key]) : null),
            minWidth: 60,
            defaultSortDesc: true,
            sortMethod: (a, b, desc) => {
              a =
                a === null
                  ? desc
                    ? -Infinity
                    : Infinity
                  : a.split('m').length > 1
                    ? a.split('m')[0] * 1000
                    : a.split('k')[0] * 1;
              b =
                b === null
                  ? desc
                    ? -Infinity
                    : Infinity
                  : b.split('m').length > 1
                    ? b.split('m')[0] * 1000
                    : b.split('k')[0] * 1;
              if (a > b) {
                return 1;
              }
              if (a < b) {
                return -1;
              }
              return 0;
            },
            filterMethod: (filter, row) => {
              let a =
                row[filter.id] === null
                  ? -Infinity
                  : row[filter.id].split('m').length > 1
                    ? row[filter.id].split('m')[0] * 1000000
                    : row[filter.id].split('k')[0] * 1000;
              if (filter.id === this.state.columns[this.state.filter0].id) {
                //'28'
                var operator = this.state.operator0;
              } else if (
                filter.id === this.state.columns[this.state.filter1].id
              ) {
                var operator = this.state.operator1;
              } else if (
                filter.id === this.state.columns[this.state.filter2].id
              ) {
                var operator = this.state.operator2;
              } else {
                return row[filter.id] === filter.value;
              }
              if (operator === '' || operator === 'equals') {
                return a === filter.value ? row[filter.id] : null;
              } else if (operator === 'gt') {
                return a > filter.value ? row[filter.id] : null;
              } else if (operator === 'lt') {
                return a < filter.value ? row[filter.id] : null;
              }
              return 0;
            }
          }
          /*
          {
            Header: 'H Change',
            id: '29',
            accessor: d =>
              d.stats.find(
                x => x.year === season && x.season_type === season_type
              ) &&
              d.stats.find(
                x =>
                  x.year === (season - 10001).toString() &&
                  x.season_type === season_type
              )
                ? d.stats.find(
                    x => x.year === season && x.season_type === season_type
                  )[key] &&
                  d.stats.find(
                    x =>
                      x.year === (season - 10001).toString() &&
                      x.season_type === season_type
                  )[key]
                  ? round(
                      d.stats.find(
                        x => x.year === season && x.season_type === season_type
                      )[key] -
                        d.stats.find(
                          x =>
                            x.year === (season - 10001).toString() &&
                            x.season_type === season_type
                        )[key]
                    )
                  : null
                : null,
            minWidth: 60,
            defaultSortDesc: true,
            sortMethod: (a, b, desc) => {
              a =
                a === null
                  ? desc
                    ? -Infinity
                    : Infinity
                  : a.split('m').length > 1
                    ? a.split('m')[0] * 1000
                    : a.split('k')[0] * 1;
              b =
                b === null
                  ? desc
                    ? -Infinity
                    : Infinity
                  : b.split('m').length > 1
                    ? b.split('m')[0] * 1000
                    : b.split('k')[0] * 1;
              if (a > b) {
                return 1;
              }
              if (a < b) {
                return -1;
              }
              return 0;
            },
            filterMethod: (filter, row) => {
              let a =
                row[filter.id] === null
                  ? -Infinity
                  : row[filter.id].split('m').length > 1
                    ? row[filter.id].split('m')[0] * 1000000
                    : row[filter.id].split('k')[0] * 1000;
              if (filter.id === this.state.columns[this.state.filter0].id) {
                //'28'
                var operator = this.state.operator0;
              } else if (
                filter.id === this.state.columns[this.state.filter1].id
              ) {
                var operator = this.state.operator1;
              } else if (
                filter.id === this.state.columns[this.state.filter2].id
              ) {
                var operator = this.state.operator2;
              } else {
                return row[filter.id] === filter.value;
              }
              if (operator === '' || operator === 'equals') {
                return a === filter.value ? row[filter.id] : null;
              } else if (operator === 'gt') {
                return a > filter.value ? row[filter.id] : null;
              } else if (operator === 'lt') {
                return a < filter.value ? row[filter.id] : null;
              }
              return 0;
            }
          } */
        ];
        newColumns.push(cols[0]);
      } else {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: value.toString(),
          accessor: d => d[key],
          minWidth: 50
        });
      }
    });
    newColumns.sort(function(a, b) {
      return a.id - b.id;
    });
    return newColumns;
  }

  render() {
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-around',
            color: '#4f738e',
            alignItems: 'center',
            paddingBottom: '1em'
          }}
        >
          <div>
            <div onClick={e => this.toSkaters(e)} className="filterButton">
              <strong>Skaters</strong>
            </div>
            <div onClick={e => this.toGoalies(e)} className="filterButton">
              <strong>Goalies</strong>
            </div>
          </div>
          <div style={{ display: 'flex' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <strong>Search:</strong>
              <strong>Season:</strong>
              <strong>League:</strong>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ paddingBottom: '1em' }}>
                <input
                  onChange={e => this.handleChange(e, 0)}
                  placeholder={'Search Players'}
                  className="filter"
                />
              </div>
              <div style={{ paddingBottom: '1em' }}>
                <select onChange={e => this.changeSeason(e)} className="filter">
                  {this.state.league === 'nhl' && (
                    <option value="20182019">2018-2019</option>
                  )}
                  <option value="20172018">2017-2018</option>
                  <option value="20162017">2016-2017</option>
                  <option value="20152016">2015-2016</option>
                  <option value="20142015">2014-2015</option>
                  <option value="20132014">2013-2014</option>
                  <option value="20122013">2012-2013</option>
                </select>
              </div>
              <div style={{ paddingBottom: '1em' }}>
                <select onChange={e => this.changeLeague(e)} className="filter">
                  <option value="nhl">NHL</option>
                  <option value="ahl">AHL</option>
                  <option value="shl">SHL</option>
                  <option value="whl">WHL</option>
                  <option value="ohl">OHL</option>
                  <option value="qmjhl">QMJHL</option>
                  <option value="ushl">USHL</option>
                </select>
              </div>
              {/*
                            <div style={{paddingBottom: '1em'}}>
                                <input onChange={(e) => this.handleChange(e, 0)} placeholder={"Enter Date"} className="filter" />
                            </div>

              <div
                onChange={e => this.handleChange(e, 1)}
                style={{ paddingBottom: '1em' }}
              >
                <select
                  onChange={e => this.handleChange(e, 1)}
                  className="filter"
                >
                  <option value="">All</option>
                  <AppContext.Consumer>
                    {context =>
                      context.number.map(item => (
                        <option value={item.abbreviation}>
                          {item.full_team_name}
                        </option>
                      ))
                    }
                  </AppContext.Consumer>
                </select>
              </div>*/}
            </div>
          </div>
          <div style={{ display: 'flex' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <strong>Type:</strong>
              {/*<strong>Situation:</strong>*/}
              <strong>Team:</strong>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div
                onChange={e => this.changeColumnType(e)}
                style={{ paddingBottom: '1em' }}
              >
                <select
                  onChange={e => this.changeColumnType(e)}
                  className="filter"
                >
                  <option value="basic">Basic</option>
                  <option value="advanced">Advanced</option>
                </select>
              </div>
              {/*<div onChange={(e) => this.handleChange(e, 4)} style={{paddingBottom: '1em'}}>
                            <select className="filter">
                                <option value="">All</option>
                                <option value="even">Even Strength</option>
                                <option value="SH">Short Handed</option>
                                <option value="PP">Power Play</option>
                            </select>
                        </div>/*/}
              {this.state.league === 'nhl' && (
                <div
                  onChange={e => this.handleChange(e, 1)}
                  style={{ paddingBottom: '1em' }}
                >
                  <select
                    onChange={e => this.handleChange(e, 1)}
                    className="filter"
                  >
                    <option value="">All</option>
                    <AppContext.Consumer>
                      {context =>
                        context.number.map(item => (
                          <option value={item.abbreviation}>
                            {item.full_team_name}
                          </option>
                        ))
                      }
                    </AppContext.Consumer>
                  </select>
                </div>
              )}
            </div>
          </div>
          <div style={{ display: 'flex' }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                paddingRight: '1em'
              }}
            >
              <strong className="radioFilters">Handed:</strong>
              <strong className="radioFilters">Season Type:</strong>
              <strong className="radioFilters">Position:</strong>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div
                onChange={e => this.handleChange(e, 3)}
                style={{ display: 'flex', paddingBottom: '1em' }}
              >
                <div className="radioButton">
                  <label>ALL</label>
                  <input type="radio" name="handed" value="" />
                </div>
                <div className="radioButton">
                  <label>LH</label>
                  <input type="radio" name="handed" value="L" />
                </div>
                <div className="radioButton">
                  <label>RH</label>
                  <input type="radio" name="handed" value="R" />
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column'
                }}
              >
                <div
                  style={{ display: 'flex', paddingBottom: '1em' }}
                  onChange={e => this.changeSeasonType(e)}
                >
                  <div className="radioButton">
                    <label>Regular</label>
                    <input type="radio" name="season" value="02" />
                  </div>
                  <div className="radioButton">
                    <label>Playoffs</label>
                    <input type="radio" name="season" value="03" />
                  </div>
                </div>
              </div>
              <div style={{ paddingBottom: '1em' }}>
                <select
                  onChange={e => this.handleChange(e, 2)}
                  className="filter"
                  style={{ width: '100%', padding: 0, margin: 0 }}
                >
                  <option value="">All</option>
                  <option value="C">C</option>
                  <option value="LW">LW</option>
                  <option value="RW">RW</option>
                  <option value="LD">LD</option>
                  <option value="RD">RD</option>
                  <option value="G">G</option>
                </select>
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <strong style={{ padding: 0 }}>Filter Results By:</strong>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-around'
              }}
            >
              <select
                onChange={e => this.changeFilter(e, 0)}
                className="filter"
                style={{ margin: '0.5em' }}
              >
                {this.state.data.columns &&
                  this.state.data.columns[this.state.column_type] &&
                  this.state.data.columns[this.state.column_type].map(
                    (key, value) =>
                      key[2] && <option value={value}>{key[2]}</option>
                  )}
              </select>
              <select
                onChange={e => this.changeModifier(e, 0)}
                className="filter"
                style={{ width: '60px', margin: '0.5em' }}
              >
                <option value="gt">&gt;</option>
                <option value="lt">&lt;</option>
                <option value="equals">=</option>
              </select>
              <input
                onChange={e => this.handleChange(e, this.state.filter0)}
                placeholder={'Number'}
                className="filter"
                style={{ margin: '0.5em' }}
              />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-around'
              }}
            >
              <select
                onChange={e => this.changeFilter(e, 1)}
                className="filter"
                style={{ margin: '0.5em' }}
              >
                {this.state.data.columns &&
                  this.state.data.columns[this.state.column_type] &&
                  this.state.data.columns[this.state.column_type].map(
                    (key, value) =>
                      key[2] && <option value={value}>{key[2]}</option>
                  )}
              </select>
              <select
                onChange={e => this.changeModifier(e, 1)}
                className="filter"
                style={{ width: '60px', margin: '0.5em' }}
              >
                <option value="gt">&gt;</option>
                <option value="lt">&lt;</option>
                <option value="equals">=</option>
              </select>
              <input
                onChange={e => this.handleChange(e, this.state.filter1)}
                placeholder={'Number'}
                className="filter"
                style={{ margin: '0.5em' }}
              />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-around'
              }}
            >
              <select
                onChange={e => this.changeFilter(e, 2)}
                className="filter"
                style={{ margin: '0.5em' }}
              >
                {this.state.data.columns &&
                  this.state.data.columns[this.state.column_type] &&
                  this.state.data.columns[this.state.column_type].map(
                    (key, value) =>
                      key[2] && <option value={value}>{key[2]}</option>
                  )}
              </select>
              <select
                onChange={e => this.changeModifier(e, 2)}
                className="filter"
                style={{ width: '60px', margin: '0.5em' }}
              >
                <option value="gt">&gt;</option>
                <option value="lt">&lt;</option>
                <option value="equals">=</option>
              </select>
              <input
                onChange={e => this.handleChange(e, this.state.filter2)}
                placeholder={'Number'}
                className="filter"
                style={{ margin: '0.5em' }}
              />
            </div>
          </div>
        </div>
        {this.state.columns.length > 1 && (
          <ReactTable
            data={this.state.players}
            ref="researchTable"
            openExpand={this.openExpand}
            defaultFilterMethod={(filter, row) => {
              if (filter.id === this.state.columns[this.state.filter0].id) {
                var operator = this.state.operator0;
              } else if (
                filter.id === this.state.columns[this.state.filter1].id
              ) {
                var operator = this.state.operator1;
              } else if (
                filter.id === this.state.columns[this.state.filter2].id
              ) {
                var operator = this.state.operator2;
              } else {
                return row[filter.id] === filter.value;
              }
              if (operator === '' || operator === 'equals') {
                return row[filter.id] === filter.value;
              } else if (operator === 'gt') {
                return row[filter.id] > filter.value;
              } else if (operator === 'lt') {
                return row[filter.id] < filter.value;
              }
            }}
            sorted={this.state.sorted}
            onSortedChange={sorted => {
              this.setState({ sorted });
            }}
            defaultSortDesc={true}
            defaultSorted={[{ id: '10', desc: true }]}
            defaultSortMethod={(a, b, desc) => {
              a = a === null ? (desc ? -Infinity : Infinity) : a;
              b = b === null ? (desc ? -Infinity : Infinity) : b;
              if (a > b) {
                return 1;
              }
              if (a < b) {
                return -1;
              }
              return 0;
            }}
            getTrProps={(instance, rowInfo) => ({
              onClick: () => {
                this.state.league === 'nhl' &&
                  this.openExpand(instance.data[rowInfo.index].player_id);
              }
            })}
            noDataText={
              <FadeLoader color={'#123abc'} loading={this.state.loading} />
            }
            getNoDataProps={(state, rowInfo, column, instance) => {
              return { style: { background: 'none' } };
            }}
            columns={this.state.columns}
            style={{ minWidth: '95em' }}
            defaultPageSize={30}
            className="-striped -highlight NonRostered ResearchTable"
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    state
  };
}

const connectedResearchTable = connect(mapStateToProps)(ResearchTable);
export { connectedResearchTable as ResearchTable };



// WEBPACK FOOTER //
// ./src/Components/ResearchTable.js